import React, { createContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import useMode from '../hooks/useMode';
import { jsx as _jsx } from "react/jsx-runtime";
var ThemeContext = /*#__PURE__*/createContext({});
function ThemeProvider(_ref) {
  var children = _ref.children,
    defaultMode = _ref.defaultMode,
    storageId = _ref.storageId,
    getModeFromStore = _ref.getModeFromStore,
    setModeToStore = _ref.setModeToStore;
  var _useMode = useMode({
      defaultMode: defaultMode,
      storageId: storageId,
      getModeFromStore: getModeFromStore,
      setModeToStore: setModeToStore
    }),
    modeSetting = _useMode.modeSetting,
    updateMode = _useMode.updateMode,
    toggleMode = _useMode.toggleMode,
    modeDisplayed = _useMode.modeDisplayed,
    updateWindowStyles = _useMode.updateWindowStyles;
  var memoizedValue = useMemo(function () {
    return {
      modeSetting: modeSetting,
      updateMode: updateMode,
      toggleMode: toggleMode,
      modeDisplayed: modeDisplayed,
      updateWindowStyles: updateWindowStyles
    };
  }, [modeSetting, updateMode, toggleMode, modeDisplayed, updateWindowStyles]);
  return /*#__PURE__*/_jsx(ThemeContext.Provider, {
    value: memoizedValue,
    children: children
  });
}
process.env.NODE_ENV !== "production" ? ThemeProvider.propTypes = {
  /**
   * Default mode value for uncontrolled component.
   * When user hasn't yet selected a mode (nothing is stored in `localStorage`)
   * the component will use this value instead.
   * */
  defaultMode: PropTypes.oneOf(['light', 'dark', 'auto']),
  /**
   * Override for the `localStorage` id used by Screentone.
   * Normally, you should not need to change this.
   * Ignored if `getModeFromtStore` or `setModeToStore` are defined.
   * */
  storageId: PropTypes.string,
  /**
   * Function that fetches the user settings from a store. `() => someInternalState.mode`.
   * Will default to fetching from `localStorage` if not set.
   */
  getModeFromStore: PropTypes.func,
  /**
   * Function that accepts a string and writes that into a store. `(m) => someAPI.write(m)`.
   * Will default to writing to `localStorage` if not set.
   */
  setModeToStore: PropTypes.func
} : void 0;
ThemeProvider.defaultProps = {
  storageId: 'st-mode',
  defaultMode: 'auto',
  getModeFromStore: null,
  setModeToStore: null
};
export default ThemeProvider;
export { ThemeContext, useMode };